if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        // カートページ遷移を指定されたフォームは Ajax 化せず、通常のフォーム送信（/cart/add → /cart）に任せる
        const redirectToCart = this.dataset.cartRedirect === 'true';
        if (!redirectToCart) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && !redirectToCart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const crossSell = this.form.querySelector('cta-cross-sell');
        const crossVariantId = crossSell?.variantId;
        // 有料オプション（addon-option.js）は本体と同じ数だけ入れる。要素はフォームの外（サイズ選択の直下）にある。
        // form.id はフォーム内の name="id" の入力欄を指してしまうので getAttribute で読む
        const addonVariantId = document.querySelector(`addon-option[data-form="${this.form.getAttribute('id')}"]`)?.variantId;
        const mainQuantity = formData.get('quantity') || '1';
        const extraItems = [];
        if (crossVariantId) extraItems.push([crossVariantId, '1']);
        if (addonVariantId) extraItems.push([addonVariantId, mainQuantity]);
        const hasExtras = extraItems.length > 0;
        if (hasExtras) {
          // Preserve all original form fields, moving line-specific fields to item 0.
          const bundleData = new FormData();
          for (const [key, value] of formData.entries()) {
            if (key.startsWith('cross-color-')) continue;
            if (['id', 'quantity', 'selling_plan'].includes(key)) {
              bundleData.append(`items[0][${key}]`, value);
            } else if (key.startsWith('properties[')) {
              bundleData.append(`items[0][properties]${key.slice('properties'.length)}`, value);
            } else {
              bundleData.append(key, value);
            }
          }
          if (!formData.has('quantity')) bundleData.append('items[0][quantity]', '1');
          extraItems.forEach(([id, quantity], i) => {
            bundleData.append(`items[${i + 1}][id]`, id);
            bundleData.append(`items[${i + 1}][quantity]`, quantity);
          });
          config.body = bundleData;
        } else {
          // UI controls must not become product properties or additional cart items.
          for (const key of [...formData.keys()]) {
            if (key.startsWith('cross-color-')) formData.delete(key);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              return;
            } else if (!this.cart) {

              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            // Notifications expect a single line key; drawer sections already contain both items.
            if (hasExtras && this.cart.tagName === 'CART-NOTIFICATION') {
              window.location = window.routes.cart_url;
              return;
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (hasExtras) this.handleErrorMessage('追加結果を確認できませんでした。カートを確認してから、もう一度お試しください。');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            crossSell?.update?.();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
